import gsap from "gsap";
import onOpenModal from "./onOpenModal";
import { ModalOptions } from "../types";

// TODO: open modal for other sections
const openModal = (
  elName: string,
  options: ModalOptions = { section: null, typology: null },
): void => {
  const {
    section, // should be: "about", "contacts", "guitars"
    typology, // should be: "series" or "guitar"
  } = options;
  try {
    onOpenModal(elName, { section, typology });

    gsap.to(".overlay__modal", {
      opacity: 1,
      display: "block",
      transform: "translateX(0)",
      duration: 1,
      ease: "power3.inOut",
    });
  } catch (error) {
    console.error("[openModal]:", error);
  }
};

export default openModal;
